// src/components/Footer.js
import React from "react";
import { Link } from "react-router-dom";

const MAX_WIDTH = 1500;

export default function Footer() {
  return (
    <footer
      style={{
        marginTop: 20,
        width: "100%",
      }}
    >
      <div
        className="glass-container"
        style={{
          width: "100%",
          margin: "0 auto 20px",
          padding: "10px clamp(16px, 4vw, 56px)",
          fontFamily: "var(--font-main)",
          color: "var(--color-text)",
          boxSizing: "border-box",
          borderRadius: 0,
        }}
      >
        <div
          style={{
            maxWidth: MAX_WIDTH,
            margin: "0 auto",
            display: "flex",
            flexWrap: "wrap",
            gap: 12,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ opacity: 0.8, fontSize: 14 }}>
            © {new Date().getFullYear()} Matematron
          </div>

          <nav
            aria-label="Linki prawne"
            style={{ display: "flex", gap: 14, flexWrap: "wrap" }}
          >
            <Link to="/cennik" style={linkStyle}>Cennik</Link>
            <Link to="/regulamin" style={linkStyle}>Regulamin</Link>
            <Link to="/polityka-prywatnosci" style={linkStyle}>Polityka prywatności</Link>
            <button
              type="button"
              onClick={() => window.dispatchEvent(new Event("matematron:privacy-settings"))}
              style={{ ...linkStyle, borderTop: 0, borderRight: 0, borderLeft: 0, background: "none", cursor: "pointer" }}
            >
              Ustawienia cookies
            </button>
            {/* Instagram (zewnętrzny) – podmień href na właściwy profil */}
            <a
              href="https://www.instagram.com/matematron" // TODO: podmień na właściwy, jeśli inny
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
              aria-label="Instagram Matematron (otwiera się w nowej karcie)"
              title="Instagram"
            >
              Instagram
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}

const linkStyle = {
  textDecoration: "none",
  borderBottom: "1px dashed var(--color-border)",
  paddingBottom: 1,
  color: "var(--color-text)",
  fontSize: 14,
};
